import { Navigate } from 'react-router-dom';
import { SessionService } from '../../../domain/services';
import { useUserService } from '../../hooks';
import { Roles } from '../../../utils/roles';

interface Props {
  children: JSX.Element;
  onlyDoctor?: boolean;
}

const ProtectedRoute = ({ children, onlyDoctor = false }: Props) => {
  const UserService = useUserService();

  if (!SessionService.isAuthenticated()) return <Navigate to='/' replace />;

  if (onlyDoctor && !UserService.hasRole(Roles.doctor)) return <Navigate to='/' replace />;

  return children;
};

export default ProtectedRoute;
